function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);

    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
}

function splider() {

    initSplide('.slider-with-text', {
        perPage: 1,
        perMove: 1,
        drag   : 'free',
        snap   : true,
        // pagination: false,
        // arrows: false,
        gap: 0,
        autoplay: true,
        type   : 'loop',
    });


}

document.addEventListener('DOMContentLoaded', splider);